import React, { useEffect, useMemo, useState } from 'react';
import { useUserContext } from '../../contexts';
import { meFn } from '../../lib/api';
import { Modal } from '../Modal';
import './TermsConsentModal.scss';

const TERMS_URL = 'https://www.productioncrate.com/terms-embed.html';
const PRIVACY_URL = 'https://www.productioncrate.com/privacy.html';
const DISABLED_PATHS = [
    /^\/register(\/|$)/,
    /^\/teams(\/|$)/,
    /^\/enterprise(\/|$)/,
    /^\/signup(\/|$)/,
    /^\/upgrade(\/|$)/,
];

const TermsConsentModal = () => {
    const { user, isAuthenticating, reloadCurrentUser } = useUserContext();
    const [dismissed, setDismissed] = useState(false);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        setDismissed(false);
    }, [user?.id]);

    const needsConsent = useMemo(() => {
        if (!user) {
            return false;
        }
        const settings = user.settings && typeof user.settings === 'object' ? user.settings : {};
        const optInValue = settings.terms_privacy_optin;
        const hasOptIn = optInValue === true || optInValue === 'true' || optInValue === 1 || optInValue === '1' || !!settings.terms_privacy_optin_at;
        return !hasOptIn;
    }, [user]);

    const isDisabledRoute = useMemo(() => {
        const path = window?.location?.pathname || '';
        return DISABLED_PATHS.some((rule) => rule.test(path));
    }, []);

    const visible = !!user && !isAuthenticating && needsConsent && !dismissed && !isDisabledRoute;

    if (!visible) {
        return null;
    }

    const handleClose = () => {
        setDismissed(true);
    };

    const handleAgree = async () => {
        if (saving) {
            return;
        }
        setSaving(true);
        const payload = {
            terms_privacy_optin: true,
            terms_privacy_optin_at: new Date().toISOString(),
        };
        try {
            await meFn(payload);
            try {
                await reloadCurrentUser?.();
            } catch (e) {
                // non-blocking
            }
            setDismissed(true);
        } catch (e) {
            console.log('terms consent update failed', e);
        } finally {
            setSaving(false);
        }
    };

    const message = (
        <div className="terms-consent">
            <div className="terms-consent__intro">
                Please review and accept the Terms and Privacy Policy to continue.
            </div>
            <div className="terms-consent__frame">
                <iframe title="ProductionCrate Terms and Conditions" src={TERMS_URL} />
            </div>
            <div className="terms-consent__links">
                <a className="terms-consent__link" target="_blank" rel="noreferrer" href={TERMS_URL}>
                    Open Terms
                </a>
                <span className="terms-consent__dot">·</span>
                <a className="terms-consent__link" target="_blank" rel="noreferrer" href={PRIVACY_URL}>
                    Privacy Policy
                </a>
            </div>
        </div>
    );

    return (
        <Modal
            visible={visible}
            title="Terms and Conditions"
            msg={message}
            cta={saving ? 'Saving...' : 'I Agree'}
            ctaCallback={handleAgree}
            ctaDisabled={saving}
            showCloseIcon={false}
            className="terms-consent-modal"
        />
    );
};

export default TermsConsentModal;
